const cleanValue = (value) => `${value ?? ''}`.trim()

const getBrands = (response) => {
  if (Array.isArray(response)) return response
  if (Array.isArray(response?.brands)) return response.brands
  return []
}

export const findBrandDetails = (response, identifier) => {
  const lookupValue = cleanValue(identifier)
  const brand = getBrands(response).find((item) =>
    [item.id, item.brand_id, item.slug].map(cleanValue).includes(lookupValue),
  )

  if (!brand) return null

  // The AssetHub project and the statuses come from /details instead.
  return {
    brandId: cleanValue(brand.brand_id),
    brandType: cleanValue(brand.brand_type),
    categoryId: cleanValue(brand.category_id),
    id: cleanValue(brand.id),
    name: cleanValue(brand.name),
    slug: cleanValue(brand.slug),
  }
}
